<script>
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import sattalep from "@/models/sattalep";
import formdate from "../formcomponet/formdate.vue";
import forminput from "../formcomponet/forminput.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
//import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import sattalepmalzeme from "../sattalepmalzeme/index.vue";
import BirimSecimi from "../formcomponet/BirimSecimiAnaBirim.vue";
export default {
  mixins: [apibtoast, apigeneric, sattalep],
  props: ["Id", "AddEdit"],
  page: {
    title: "Talep",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    formdate,
    forminput,
    formcombobox,
 //   Treeselect,
    sattalepmalzeme,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("sattalep.Title"),
      items: [
        {
          text: this.$t("sattalep.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("sattalep.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("sattalep.Title"),
          active: true,
        },
      ],
      FormData: {},
    };
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("sattalep", this.FormData).then((res) => {
            if (res) {
              this.AddEdit = "Edit";
              this.EditId = res;
              this.FormData.Id = res;
            }
          });
        } else {
          this.Update("sattalep", this.FormData).then((res) => {
            if (res) {
              
              this.EditId = this.FormData.Id;
              this.$emit("Update", this.FormData);
          this.$bvModal.hide("sattalep"); 
            }
          });
        }
      }
    },
    Get() {
     /* if (this.AddEdit == "Edit") {
        this.ActionsSingleGet({ Service: "sattalep", Id: this.EditId }).then((res) => {
          this.FormData = res.Data;
          this.FormData.Taleptarih = this.$options.filters.formatDate(this.FormData.Taleptarih);
        });
      }*/
    },
  },
};
</script>

<template>
  <Loader>
    <b-modal id="sattalep" size="xl" :title="this.AddEdit == 'Edit' ? $t('sattalep.AddEdit.FormTitleEdit') : $t('sattalep.AddEdit.FormTitleAdd')" title-class="font-18" hide-footer>
      <div class="row" v-if="FormData.Onaydurum == 1">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <Form @submit.prevent="onSubmit">
                  <div class="row">
                    <div class="col md-4">
                      <forminput 
                      :FormDataType="FormDataType.Baslik" 
                      :Value="FormData.Baslik" 
                      :v="$v.FormData.Baslik" 
                      @input="FormData.Baslik = $event" 
                      :Disabled="FormData.Taleptoplamasontarih ? true : false"
                      />
                    </div>
                    <div class="col md-4">
                      <formdate 
                      :FormDataType="FormDataType.Taleptarih" 
                      :Value="FormData.Taleptarih" 
                      :v="$v.FormData.Taleptarih" 
                      @input="FormData.Taleptarih = $event" 
                      :Disabled="FormData.Taleptoplamasontarih ? true : false"
                      />
                    </div>

                  </div>

                  <div class="row">
                    <div class="col md-4">
                      <BirimSecimi
                        :title="FormDataType.Birimid.FieldTitle"
                        :sutun="'0'" 
                        :title_class="'mb-3'"
                        :selected="FormData.Birimid" 
                        :v="$v.FormData.Birimid"
                        :YetkiKontrol="1"
                        :multiple="false"
                        :BirimTipId="null"
                        @Secilmis_Idler="FormData.Birimid=$event"
                        :Disabled="FormData.Taleptoplamasontarih ? true : false"
                        
                      />
                      
                    </div>


                    <div class="col md-4">
                      <formcombobox 
                      :FormDataType="FormDataType.Kullanicigerceklestirmeid" 
                      :Value="FormData.Kullanicigerceklestirmeid" 
                      :v="$v.FormData.Kullanicigerceklestirmeid" 
                      @input="FormData.Kullanicigerceklestirmeid = $event" />
                    </div>
            <!--      <div class="col md-4">
                      <formcombobox 
                      :FormDataType="FormDataType.Kullanicitasinirid" 
                      :Value="FormData.Kullanicitasinirid" 
                      :v="$v.FormData.Kullanicitasinirid" 
                      @input="FormData.Kullanicitasinirid = $event" />
                    </div>
                    <div class="col md-4">
                      <formcombobox 
                      :FormDataType="FormDataType.Kullaniciharcamaid" 
                      :Value="FormData.Kullaniciharcamaid" 
                      :v="$v.FormData.Kullaniciharcamaid" 
                      @input="FormData.Kullaniciharcamaid = $event" />
                    </div> -->  
                  </div>

         <!--        <div class="row">
                    <div class="col md-4">
                      <formcombobox 
                      :FormDataType="FormDataType.Harcamatipid" 
                      :Value="FormData.Harcamatipid" 
                      :v="$v.FormData.Harcamatipid" 
                      @input="FormData.Harcamatipid = $event"
                      :Disabled="FormData.Taleptoplamasontarih ? true : false"
                      />
                    </div>
                    <div class="col md-4">
                      <b-form-group 
                      class="mb-3" 
                      id="example text" 
                      :label="FormDataType.Sartnametip.FieldTitle" 
                      label-for="text">
                        <treeselect 
                        :multiple="true" 
                        :options="FormDataType.Sartnametip.ComboDataArray" 
                        :placeholder="$t('OrtakKullanim.seciniz')" 
                        v-model="FormData.Sartnametip" 
                      :disabled="FormData.Taleptoplamasontarih ? true : false"
                        :class="{ 'is-invalid': $v.FormData.Sartnametip.$error }" />
                        <treeselect-value :value="FormData.Sartnametip" />

                        <div v-if="$v.FormData.Sartnametip.$error" class="invalid-feedback">
                          <span v-if="$v.FormData.Sartnametip.required == false">
                            {{ $t("ValidationMessage.required") }}
                          </span>
                        </div> 
                      </b-form-group>
                    </div> 
                  </div> --> 
                  <button class="btn btn-primary" type="submit">
                    {{ $t("sattalep.AddEdit.Button") }}
                  </button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="AddEdit == 'Edit'">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <sattalepmalzeme :Talepid="FormData.Id" :OnayDurum="FormData.Onaydurum" :Taleptoplamasontarih="FormData.Taleptoplamasontarih" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>
